export default __webpack_public_path__ + "static/media/inner.5f055ac7.png";